var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72.9 56",
    style: {
      enableBackground: "new 0 0 72.9 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.5,11.8H12.4c-1.1,0-2,0.9-2,2s0.9,2,2,2h16.1c1.1,0,2-0.9,2-2S29.6,11.8,28.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,27.5H28c1.1,0,2-0.9,2-2s-0.9-2-2-2H12.2c-1.1,0-2,0.9-2,2S11.1,27.5,12.2,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,34.6H12.7c-1.1,0-2,0.9-2,2s0.9,2,2,2h15.5c1.1,0,2-0.9,2-2S29.3,34.6,28.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.8,0.3H44.3c-2.4,0-5.7,0-7.8,2.4c-2.1-2.4-5.4-2.4-7.8-2.4H10.2c-4.6,0-9.6,0.8-9.8,9.8v30.4 c0,3.5,0.7,6,2.3,7.6c2,2,4.9,2.2,7.4,2.2c0,0,0,0,0,0l19.4,0.2c0.9,0,1.7,0.4,2.3,1.1l3.2,3.1c0.1,0.3,0.3,0.6,0.6,0.8 c0.4,0.3,0.8,0.4,1.2,0.4c0.5,0,0.9-0.2,1.3-0.5l0,0c0.1-0.1,0.2-0.2,0.3-0.3l2.7-3.5c0.6-0.7,1.4-1.1,2.3-1.1l19.4-0.2 c2.5,0,5.4-0.2,7.5-2.2c1.6-1.6,2.4-4.1,2.3-7.6V10C72.4,1,67.5,0.3,62.8,0.3z M29.6,46.5l-19.4-0.2c-2.2,0-3.8-0.2-4.6-1 c-0.8-0.8-1.2-2.4-1.2-4.8l0-30.4c0.1-5.8,2.1-5.8,5.8-5.8h18.5c4,0,5.1,0.3,5.6,3c0.2,13.7,0.3,32.5,0.4,41.5 C33.4,47.4,31.6,46.5,29.6,46.5z M68.6,40.5c0,2.4-0.4,4-1.2,4.8c-0.8,0.9-2.4,1-4.6,1l-19.4,0.2c-1.7,0-3.4,0.7-4.7,1.9 c0-0.5,0-1.1,0-1.7c0-4.4-0.1-10.3-0.1-16.1c-0.1-9.7-0.2-19.4-0.2-22.4c0.2-0.2,0.3-0.5,0.4-0.8c0.5-2.6,1.6-3,5.6-3h18.5 c3.7,0,5.7,0,5.8,5.8V40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,15.8h16.1c1.1,0,2-0.9,2-2s-0.9-2-2-2H44.5c-1.1,0-2,0.9-2,2S43.4,15.8,44.5,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.7,23.5H45c-1.1,0-2,0.9-2,2s0.9,2,2,2h15.8c1.1,0,2-0.9,2-2S61.8,23.5,60.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,34.6H44.8c-1.1,0-2,0.9-2,2s0.9,2,2,2h15.5c1.1,0,2-0.9,2-2S61.4,34.6,60.3,34.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingSm);
export default __webpack_public_path__ + "static/media/training_sm.d6e51c26cc4092e24517e9c95d8c8f49.svg";
export { ForwardRef as ReactComponent };